import LegalPage from "@/pages/legal/LegalPage";

export default function Cookies() {
  return (
    <LegalPage
      testid="cookies-page"
      draft
      title="Cookie Policy"
      updated="2026-06-01"
      intro="Trifit.XPS uses a deliberately small number of cookies. We do not run advertising cookies and we do not sell data to third parties."
      sections={[
        { h: "What we set", p: [[
          "session_token · a strictly necessary, HTTP-only cookie that keeps you signed in for up to seven days. Without it you cannot use the platform.",
          "Sign-in state from Google, when you choose to sign in with Google, is handled by Google's own cookies on their domain during the consent step.",
          "Local browser storage is used to remember interface preferences such as which columns you have chosen to show in a table.",
        ]]},
        { h: "What we do not set", p: [
          "No advertising, retargeting or cross-site tracking cookies. No third-party analytics profiling of individual athletes.",
        ]},
        { h: "Managing cookies", p: [
          "You can clear or block cookies in your browser settings. Blocking the session cookie will sign you out and prevent access to the platform, because it is required for authentication.",
        ]},
        { h: "Changes", p: [
          "If we add any cookie beyond the strictly necessary session cookie, this page will be updated and, where the law requires it, we will ask for your consent first.",
        ]},
      ]}
    />
  );
}
